import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { Platform } from '@ionic/angular';
import { AppVersionService } from './appversion.service';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private storage: StorageService,
    private platform: Platform,
    private appVersion: AppVersion,
    private appVersionService: AppVersionService
  ) { }

  async get(url: string, params: any = {}, isAuthenticated = true, baseUrl = environment.svpeUrl) {

    const requestParams = {
      params : params || {},
      headers: {}
    };

    if (isAuthenticated) {
      const user = await this.storage.get('user');
      requestParams.headers = {
        Authorization: `Bearer ${user.token || null}`,
        // device: (this.platform.is('android') || this.platform.is('iphone')) && !this.platform.is('mobileweb') ? 'SM' : 'WEB'
      };
    }

    if (url.includes('updateusersynchronisationdate') ||
      url.includes('UpdateUserLoginDate')
    ){
      const isMobile = (this.platform.is('android') || this.platform.is('iphone')) && !this.platform.is('mobileweb');
      const version = isMobile ? await this.appVersion.getVersionNumber() : this.appVersionService.getStoredVersion()?.version;

      requestParams.headers['device'] = isMobile ? 'SM' : 'WEB';
      requestParams.headers['appVersion'] = version;
    }

    return this.http.get(baseUrl + url, requestParams)
    .toPromise();
  }

  async post(url: string, body: any = {}, isAuthenticated = true, baseUrl = environment.svpeUrl) {

    const requestParams = body || {};
    const httpOptions = {
      headers: {}
    };

    if (isAuthenticated) {
      const user = await this.storage.get('user');
      httpOptions.headers = {
        Authorization: `Bearer ${user.token || null}`,
        // device: (this.platform.is('android') || this.platform.is('iphone')) && !this.platform.is('mobileweb') ? 'SM' : 'WEB'
      };
    }

    // if (url.includes('import') || url === 'verifications/synchronisation') {
    // lors de import (import/ synchro), send device type
    if (url.includes('import') ||
    (url.includes('synchronisation') && !url.includes('updateusersynchronisationdate'))) {
      httpOptions.headers['device'] = (this.platform.is('android') || this.platform.is('iphone')) && !this.platform.is('mobileweb') ? 'SM' : 'WEB';
    }

    return this.http.post(baseUrl + url, requestParams, httpOptions)
    .toPromise();
  }
}
